<template>
  <div class="cf-headerWrapper">
    <div class="cf-headerContainer">
      <span class="cf-headerTitle">Engagement Calculators</span>
      <div class="cf-entityNames">
        {{ clientName }}
        {{ partnerName == "" ? "" : "and " + partnerName }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_CLIENT_INFORMATION } from "../helpers/vuex-constants";
export default {
  name: "cash-flow-header",
  props: {
    clientName: String,
    partnerName: String,
  },
  mounted() {
    // let data = window.location.href;
    // if (data.indexOf("invest") >= 0) {
    //   this.isLoanSelected = false;
    // } else {
    //   this.isLoanSelected = true;
    // }
  },
  methods: {},
  computed: {
    ...mapGetters({
      getClientInformation: GET_CLIENT_INFORMATION,
    }),
  },
};
</script>

<style lang="scss" scoped>
.cf-headerWrapper {

  

  border-bottom: $mds-border-separator-on-light;
  padding-top: $mds-space-1-x;
  padding-bottom: $mds-space-1-x;
  background-color: $mds-background-color-white;
  .cf-headerContainer {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 48px;
    .cf-headerTitle {
      @include mds-level-5-heading();
    }
    .cf-entityNames {
      @include mds-level-5-heading($bold: true);
    }
  }
}
</style>
